import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-regisafe-search-toolbar',
  templateUrl: './regisafe-search-toolbar.component.html',
  styleUrls: ['./regisafe-search-toolbar.component.scss'],
})
export class RegisafeSearchToolbarComponent implements OnInit {

  @Output() emitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  submit() {
    this.emitter.emit({searchAction: 'search', random: Math.random()});
  }

  reset() {
    this.emitter.emit({searchAction: 'reset', random: Math.random()});
  }


}
